import { Component, OnInit } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection} from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.css']
})
export class StatisticsComponent implements OnInit {
  title = 'Generar <strong>Estadisticas</strong> de uso.';
  subtitle = 'Visualizar las estadisticas generadas por todos los usuarios.';
  modal = false;
  section = 0;
  url = 'https://vicinosoftware.com';
  url2 = 'https://calcularmiapp.com';
  text_twitter = 'Calcula de forma fácil el costo para crear TU %23App con @VicinoSoftware. Obtén ahora tu %23presupuesto estimado en';
  sections = [
    {
      id: 1,
      title: '¿Qué <strong>nivel</strong> de calidad estás buscando?',
      options: [
        {
          id: 1,
          hours: 24,
          img: './assets/img/2.png',
          text: 'Calidad óptima'
        },
        {
          id: 2,
          hours: 16,
          img: './assets/img/3.png',
          text: 'Buena relación calidad/precio'
        },
        {
          id: 3,
          hours: 8,
          img: './assets/img/4.png',
          text: 'No me importa tanto la calidad'
        }]
    },
    {
      id: 2,
      title: '¿Qué <strong>tipo</strong> de app necesitas?',
      options: [
        {
          id: 1,
          hours: 60,
          img: './assets/img/5.png',
          text: 'Aplicación Android'
        },
        {
          id: 2,
          hours: 60,
          img: './assets/img/6.png',
          text: 'Aplicación iOS'
        },
        {
          id: 3,
          hours: 60,
          img: './assets/img/7.png',
          text: 'Aplicación Windows Phone'
        },
        {
          id: 4,
          hours: 100,
          img: './assets/img/8.png',
          text: 'Aplicación Android + iOS'
        }]
    },
    {
      id: 3,
      title: '¿Qué <strong>diseño</strong> quieres que tenga tu App?',
      options: [
        {
          id: 1,
          hours: 40,
          img: './assets/img/9.png',
          text: 'Interfaz sencilla'
        },
        {
          id: 2,
          hours: 120,
          img: './assets/img/10.png',
          text: 'Interfaz personalizada'
        },
        {
          id: 3,
          hours: 80,
          img: './assets/img/11.png',
          text: 'Interfaz replicada de la web'
        },
        {
          id: 4,
          hours: 0,
          img: './assets/img/12.png',
          text: 'No necesito diseño'
        }]
    },
    {
      id: 4,
      title: '¿Cómo quieres sacar <strong>beneficio</strong> a tu App?',
      options: [
        {
          id: 1,
          hours: 5,
          img: './assets/img/13.png',
          text: 'Aplicación gratuita con publicidad'
        },
        {
          id: 2,
          hours: 5,
          img: './assets/img/14.png',
          text: 'Aplicación de pago'
        },
        {
          id: 3,
          hours: 40,
          img: './assets/img/15.png',
          text: 'Compras dentro de la app'
        },
        {
          id: 4,
          hours: 10,
          img: './assets/img/16.png',
          text: 'Otros / No lo sé todavía'
        }]
    },
    {
      id: 5,
      title: '¿Tu App necesita un sistema de <strong>login</strong>?',
      options: [
        {
          id: 1,
          hours: 40,
          img: './assets/img/17.png',
          text: 'Sí, con redes sociales y email'
        },
        {
          id: 2,
          hours: 25,
          img: './assets/img/18.png',
          text: 'Sí, con email'
        },
        {
          id: 3,
          hours: 0,
          img: './assets/img/19.png',
          text: 'No'
        },
        {
          id: 4,
          hours: 20,
          img: './assets/img/20.png',
          text: 'No lo sé todavía'
        }]
    },
    {
      id: 6,
      title: '¿Tu App tiene que estar <strong>integrada</strong> con un sitio web?',
      options: [
        {
          id: 1,
          hours: 40,
          img: './assets/img/21.png',
          text: 'Sí'
        },
        {
          id: 2,
          hours: 0,
          img: './assets/img/22.png',
          text: 'No'
        },
        {
          id: 3,
          hours: 20,
          img: './assets/img/23.png',
          text: 'No lo sé'
        }]
    },
    {
      id: 7,
      title: '¿Los usuarios tienen sus propios <strong>perfiles</strong>?',
      options: [
        {
          id: 1,
          hours: 40,
          img: './assets/img/24.png',
          text: 'Sí'
        },
        {
          id: 2,
          hours: 0,
          img: './assets/img/25.png',
          text: 'No'
        },
        {
          id: 3,
          hours: 20,
          img: './assets/img/26.png',
          text: 'No lo sé'
        }]
    },
    {
      id: 8,
      title: '¿Tu app necesita un <strong>panel</strong> de administración?',
      options: [
        {
          id: 1,
          hours: 40,
          img: './assets/img/27.png',
          text: 'Sí'
        },
        {
          id: 2,
          hours: 0,
          img: './assets/img/28.png',
          text: 'No'
        },
        {
          id: 3,
          hours: 20,
          img: './assets/img/29.png',
          text: 'No lo sé'
        }]
    },
    {
      id: 9,
      title: '¿Qué <strong>idiomas</strong> usará tu aplicación?',
      options: [
        {
          id: 1,
          hours: 0,
          img: './assets/img/30.png',
          text: 'Un único idioma'
        },
        {
          id: 2,
          hours: 20,
          img: './assets/img/31.png',
          text: 'Bilingüe'
        },
        {
          id: 3,
          hours: 40,
          img: './assets/img/32.png',
          text: 'Multilingüe'
        }]
    },
    {
      id: 10,
      title: '¿En qué <strong>estado</strong> se encuentra tu proyecto?',
      options: [
        {
          id: 1,
          hours: 0,
          img: './assets/img/33.png',
          text: 'Sólo es una idea'
        },
        {
          id: 2,
          hours: 0,
          img: './assets/img/34.png',
          text: 'Boceto ya preparado'
        },
        {
          id: 3,
          hours: 0,
          img: './assets/img/35.png',
          text: 'App en desarrollo'
        },
        {
          id: 4,
          hours: 0,
          img: './assets/img/36.png',
          text: 'App ya desarrollada'
        }]
    }];
  selected = [];
  answers = {
    1:  {1: {total: 0, prom: 0}, 2: {total: 0, prom: 0}, 3: {total: 0, prom: 0}},
    2:  {1: {total: 0, prom: 0}, 2: {total: 0, prom: 0}, 3: {total: 0, prom: 0}, 4: {total: 0, prom: 0}},
    3:  {1: {total: 0, prom: 0}, 2: {total: 0, prom: 0}, 3: {total: 0, prom: 0}, 4: {total: 0, prom: 0}},
    4:  {1: {total: 0, prom: 0}, 2: {total: 0, prom: 0}, 3: {total: 0, prom: 0}, 4: {total: 0, prom: 0}},
    5:  {1: {total: 0, prom: 0}, 2: {total: 0, prom: 0}, 3: {total: 0, prom: 0}, 4: {total: 0, prom: 0}},
    6:  {1: {total: 0, prom: 0}, 2: {total: 0, prom: 0}, 3: {total: 0, prom: 0}},
    7:  {1: {total: 0, prom: 0}, 2: {total: 0, prom: 0}, 3: {total: 0, prom: 0}},
    8:  {1: {total: 0, prom: 0}, 2: {total: 0, prom: 0}, 3: {total: 0, prom: 0}},
    9:  {1: {total: 0, prom: 0}, 2: {total: 0, prom: 0}, 3: {total: 0, prom: 0}},
    10: {1: {total: 0, prom: 0}, 2: {total: 0, prom: 0}, 3: {total: 0, prom: 0}, 4: {total: 0, prom: 0}}};
  data = [];
  info = {};
  start = false;

  config: Observable<{}>;
  configRef: AngularFirestoreCollection<any>;
  itemRef: AngularFirestoreCollection<any>;


  constructor(db: AngularFirestore, private httpClient: HttpClient) {
    this.itemRef = db.collection('statistics');
    this.configRef = db.collection('config');
    this.config = this.configRef.doc("config").valueChanges();
  }

  ngOnInit() {
    this.itemRef.get().subscribe((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        this.selected.push(doc.data().selected);
        this.data.push(doc.data());
      });
      this.start = true;
    });
  }

  toggleModal(): void {
    this.modal = !this.modal;
  }

  updateSection(x): void {
    this.section = x;
  }

  calculateStatistics(): void {
    this.cleanData();
    this.selected.forEach(s => {
      for (let i in s) {
        if (s[i] && s[i].option && s[i].option.id && this.sections[s[i].id - 1] && this.sections[s[i].id - 1].options[s[i].option.id - 1]) {
          this.sections[s[i].id - 1].options[s[i].option.id - 1]['total'] = (this.sections[s[i].id - 1].options[s[i].option.id - 1]['total'] ? this.sections[s[i].id - 1].options[s[i].option.id - 1]['total'] : 0) + 1;
        }
      }
    });
    this.sections.forEach(s => {
      s.options.forEach(o => {
        o['prom'] = o['total'] / this.selected.length;
      })
    });
  }

  clearStatistics(): void {
    this.sections.forEach(s => {
      s.options.forEach(o => {
        o['prom'] = 0;
        o['total'] = 0;
      })
    });
    this.data = [];
    this.info = {};
  }

  cleanData(): void{
    let data = [];
    let info = {browser:{},device:{},os:{},city:{},region:{},country:{},price:0,time:0};
    this.data.forEach((d) => {
      let selected = [];
      for (let i in d.selected) {selected.push(d.selected[i])}
      data.push({
        browser: d.browser.browser,
        device: d.browser.device,
        os: d.browser.os,
        city: d.ipRequest.city,
        country: d.ipRequest.country_name,
        ip: d.ipRequest.ip,
        region: d.ipRequest.region,
        price: d.price,
        time: d.time_finish - d.time_init,
        selected: selected
      });
      info['browser'][d.browser.browser]         = (info['browser'][d.browser.browser]         ? info['browser'][d.browser.browser]        + 1: 1);
      info['device'][d.browser.device]           = (info['device'][d.browser.device]           ? info['device'][d.browser.device]          + 1: 1);
      info['os'][d.browser.os]                   = (info['os'][d.browser.os]                   ? info['os'][d.browser.os]                  + 1: 1);
      info['city'][d.ipRequest.city]             = (info['city'][d.ipRequest.city]             ? info['city'][d.ipRequest.city]            + 1: 1);
      info['region'][d.ipRequest.region]         = (info['region'][d.ipRequest.region]         ? info['region'][d.ipRequest.region]        + 1: 1);
      info['country'][d.ipRequest.country_name]  = (info['country'][d.ipRequest.country_name]  ? info['country'][d.ipRequest.country_name] + 1: 1);
      info['price']  += d.price;
      info['time']   += d.time_finish - d.time_init;
    });
    this.data = data;
    for (let i in info) {
      if(i !== 'price' && i !== 'time')
        this.info[i] = StatisticsComponent.sortProperties(info[i]);
      else
        this.info[i] = info[i]
    }
  }

  secondsToHms(d) {
    d = Number(d);
    d = d/1000;
    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    let s = Math.floor(d % 3600 % 60);

    let hDisplay = h > 0 ? h + 'h ' : "";
    let mDisplay = m > 0 ? m + 'm ' : "";
    let sDisplay = s > 0 ? s + 's' : "";
    return hDisplay + mDisplay + sDisplay;
  }

  getKeys(obj): object {
    return Object.keys(obj)
  }

  static sortProperties(obj) {
    // convert object into array
    var sortable=[];
    for(var key in obj)
      if(obj.hasOwnProperty(key))
        sortable.push([key, obj[key]]); // each item is an array in format [key, value]

    // sort items by value
    sortable.sort(function(a, b)
    {
      return b[1]-a[1]; // compare numbers
    });
    return sortable; // array in format [ [ key1, val1 ], [ key2, val2 ], ... ]
  }

}
